import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { TaxClassificationResponseDto } from '@/types/dtos/organizations/response/tax-classification.dto';

type TaxClassificationRequestDto = {
  countryCode: string;
};

export function useTaxClassificationMutation() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (data: TaxClassificationRequestDto) => {
      const token = await getToken();
      return taxClassification(data, token ?? '');
    },
  });
}

const taxClassification = async (
  data: TaxClassificationRequestDto,
  token: string,
): Promise<TaxClassificationResponseDto> => {
  const url = `${import.meta.env.VITE_API_URL}/vat-validation/tax-classification`;
  return sendJSONRequest({ url, method: METHOD.POST, body: data, token });
};
